// jiboomba URL
// const BASE_URL = "https://staging.syscorp.in/api/v1/jiboomba";
// const BASE_URL = "https://iccpanel.com/api/v1/jiboomba";

// const BASE_URL = "https://iccpanel.com/api/v1/betwin";
// const BASE_URL = "https://staging.iccpanel.com/api/v1/betwise";
// const BASE_URL = "https://staging.iccpanel.com/api/v1/ziwa-gaming";
const BASE_URL = "https://staging.iccpanel.com/api/v1/ziwagames";
//
// const BASE_URL = "https://staging.syscorp.in/api/v1/test";

// Namibia URL
// const BASE_URL = "https://staging.syscorp.in/api/v1/test2";
// const BASE_URL = "https://staging.syscorp.in/api/v1/betwin";

export default BASE_URL;
